var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDecoIco4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7513 39.6963L17.7513 0.495384L21.4495 0.495384L21.4495 39.6963L17.7513 39.6963Z",
    fill: "#474EFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 18.2471H39.2009V21.9453H0V18.2471Z",
    fill: "#474EFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.846558 26.0918L36.9008 10.7034L38.3525 14.1048L2.29829 29.4931L0.846558 26.0918Z",
    fill: "#474EFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.10521 11.0742L38.4806 25.6872L37.1021 29.1188L0.726626 14.5059L2.10521 11.0742Z",
    fill: "#474EFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.606 1.34521L28.9944 37.3995L25.593 38.8512L10.2046 2.79695L13.606 1.34521Z",
    fill: "#474EFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6259 2.59814L14.0129 38.9736L10.5813 37.595L25.1943 1.21956L28.6259 2.59814Z",
    fill: "#474EFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecoIco4);
export default __webpack_public_path__ + "static/media/decoIco4.8259164aa21d7d1d983d9138adac2f76.svg";
export { ForwardRef as ReactComponent };